import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { List } from '@fuww/library/src/List/index';
import { useIntl } from 'react-intl';
import {
  BrandListItem,
  BrandListItemContent,
} from '@fuww/library/src/List/BrandList';
import CategoryFilter from
'@fuww/library/src/ProductFilters/CategoryFilter';
import { DirectoryPage, DirectoryLayout } from '../components/DirectoryPage';
import ImageWithUrls from '../components/ImageWithUrls';
import withApollo from '../lib/apollo';
import brandsConnectionQuery
from '../lib/queries/products/brandsConnectionQuery.graphql';
import withQuery from '../lib/withQuery';
import loadMore from '../lib/queries/loadMore';
import messages from '../lib/messages.mjs';
import segments from '../lib/segments';
import LoadMore from '../components/LoadMore';
import LinkAndAnchor from '../components/LinkAndAnchor';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import { directoryListImageConfigurations } from '../lib/imageConfigurations';
import replaceRoute from '../lib/replaceRoute';

export const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/_noS0Jf41euUYO2AYYmfCxFB9xiDwymEmnSkiDFxOi8/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9icmFuZF9kaXJlY3RvcnlfYmFubmVyX21vYmlsZS5qcGc',
    'https://r.fashionunited.com/6Z9aI2clj3Nz02OVYuQuIpE1dZmsArHYrrxDUd5xlz0/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9icmFuZF9kaXJlY3RvcnlfYmFubmVyX21vYmlsZS5qcGc',
    'https://r.fashionunited.com/4b5lWMpJk_TvsWmwrC0p-q6upfc4gnq0cxmgAg7vFPo/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9icmFuZF9kaXJlY3RvcnlfYmFubmVyX21vYmlsZS5qcGc',
  ],
  desktop: [
    'https://r.fashionunited.com/TQOGbdX03pd4ZIp24216ZhP_CV9jGMZa0Lw-_8oMq7Y/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9icmFuZF9kaXJlY3RvcnlfYmFubmVyX2Rlc2t0b3AuanBn',
    'https://r.fashionunited.com/8xd50YQO3kWr0RzJxLuzGk62-y5qRaUdUvLcSS_kX_c/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9icmFuZF9kaXJlY3RvcnlfYmFubmVyX2Rlc2t0b3AuanBn',
    'https://r.fashionunited.com/Ea0o-u3IwrQL_QkeepAmIv0z2M7rs5FtjHXU-AWM8po/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9icmFuZF9kaXJlY3RvcnlfYmFubmVyX2Rlc2t0b3AuanBn',
    'https://r.fashionunited.com/lwyONLozB_3Kjcu3dOyIJA1pgnBKK5T2Oy1mmpisCL8/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9icmFuZF9kaXJlY3RvcnlfYmFubmVyX2Rlc2t0b3AuanBn',
  ],
};

const BrandsList = ({
  data, variables, fetchMore, loading,
}) => {
  const { brandsConnection: { edges, pageInfo: { hasNextPage } } } = data;

  return (
    <>
      <List className="fu-mdc-list">
        {edges && edges.map(({
          node: {
            id, name, profiles,
          },
        }) => {
          const premiumProfile = profiles.find(
            ({ page: { premium } }) => premium === true,
          );
          const {
            page: { slug, premium, industries },
            company: { country, logoUrls },
          } = premiumProfile || profiles[0];

          return (
            <BrandListItem key={id} premium={premium}>
              <LinkAndAnchor
                route="company-profile"
                params={{ slug }}
                // hoverUnderline
              >
                <BrandListItemContent
                  title={name}
                  industries={<>{industries.join(', ')}</>}
                  country={country}
                  logo={
                    logoUrls[0] && (
                      <ImageWithUrls
                        imageUrls={logoUrls}
                        title={name}
                        alt={name}
                        width="60px"
                        height="auto"
                        objectFit="cover"
                        sizes="60px"
                        srcSet={`${logoUrls[1]
                        } 60w, ${logoUrls[2]
                        } 120w, ${logoUrls[3]
                        } 180w`}
                        disableRoundedCorners
                      />
                    )
                  }
                  premium={premium}
                />
              </LinkAndAnchor>
            </BrandListItem>
          );
        })}
      </List>
      <LoadMore
        hasNextPage={hasNextPage}
        loading={loading}
        fetchMore={
          () => loadMore({ variables })(data, 'brandsConnection', fetchMore)
        }
      />
    </>
  );
};

BrandsList.propTypes = {
  variables: PropTypes.shape({}).isRequired,
  loading: PropTypes.bool.isRequired,
  fetchMore: PropTypes.func.isRequired,
  data: PropTypes.shape({
    brandsConnection: PropTypes.shape({
      pageInfo: PropTypes.shape({
        hasNextPage: PropTypes.bool,
      }),
      edges: PropTypes.arrayOf(
        PropTypes.shape({}),
      ),
    }),
  }).isRequired,
};

const BrandsListWithQuery = withQuery(BrandsList);

export const BrandsDirectoryPage = () => {
  const intl = useIntl();
  const { query } = useRouter();
  const {
    industries,
    country,
    section,
    search,
  } = query;

  const BRANDSLIMIT = 10;

  return (
    <DirectoryPage
      title={industries ? intl.formatMessage(
        messages['brands-directory-with-industry.title'], { industries },
      ) : intl.formatMessage(messages['brands-directory.title'])}
      route="brands-directory"
      pageType="brands"
      ComponentWithQuery={BrandsListWithQuery}
      query={brandsConnectionQuery}
      variables={{
        brandSearch: search,
        first: BRANDSLIMIT,
        type: 'COMPANY',
        hasProfile: true,
        hasPremiumProfile: section !== 'all' || null,
        country: country || null,
        industries,
        imageConfigurations: directoryListImageConfigurations,
        logoConfigurations: directoryListImageConfigurations,
      }}
      routeParams={industries ? {
        industries,
      } : {}}
      filters={(
        <CategoryFilter
          categories={
            [
              {
                name: 'All',
                handleInteraction: () => {
                  const { industries: _industries, ...rest } = query;

                  replaceRoute('brands-directory', rest);
                },
              },
              ...segments.map((categoryName) => ({
                name: categoryName,
                handleInteraction: () => replaceRoute(
                  'brands-directory', {
                    ...query,
                    industries: categoryName,
                  },
                ),
              }
              )),
            ]
          }
          selectedCategory={industries || 'All'}
          name="Filter"
        />
      )}
    />
  );
};

BrandsDirectoryPage.getLayout = (page) => (
  <DirectoryLayout
    imageUrls={headerImageUrls}
    alt="FashionUnited Brands Directory"
  >
    {page}
  </DirectoryLayout>
);

BrandsDirectoryPage.getInitialProps = redirectRouteToDomain('brands-directory');

export default withApollo(BrandsDirectoryPage);
